import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { CloseCardButton } from '../common/blocks/CloseCardButton';
import { Label } from '../common/elements/Label';
import { SecondaryButton } from '../common/elements/SecondaryButton';
import { AddButton } from '../common/elements/AddButton';
import { ConfirmBox } from '../common/elements/ConfirmBox';
import { TextInput } from '../common/elements/TextInput';
import Select from '../common/elements/Select';
import { push } from 'connected-react-router';
import { Dropdown } from '../common/elements/Dropdown';
import { SCHOOL } from '../../Paths';
import { actionCreators as schoolActions } from '../../reducer/school';
import { ReactComponent as TrashImg } from '../../images/trash.svg';
import { ReactComponent as GroupImg } from '../../images/icon-group.svg';
import {
	getGroups as getSchoolGroups,
	actionCreators as groupActions,
	getGroupById,
} from '../../reducer/groups';
import { actionCreators as travellerActionCreators } from '../../reducer/traveller';
import { actionCreators as parameterActionCreators } from '../../reducer/parameters';
import {
	actionCreators as studentActions,
	hasLoadedStudentTickets,
	hasLoadedStudentBearers,
	selectStudentTickets,
	isLoadingStudentTickets,
	isUpdatingStudent,
	getStudentBearers,
	isTravelCardSmartPhone,
	getReferredAccount,
	getReferredAccountTickets,
	canDeleteGroup,
	isLoadingAddStudentToGroup,
} from '../../reducer/students';
import {
	actionCreators as orderActions,
	isSchoolTicketCancellable,
	isReferredSchoolTicketCancellable,
} from '../../reducer/school/orders';
import {
	hasCreateStudentBearerError,
	isLoadingStudentBearers,
	hasDeleteGroupStudentError,
	getStudentById,
	isLoadingGroupDeleteStudent,
	getAllTicketOrderProducts,
} from '../../reducer';
import withTextContext from '../../utils/withTextContext';
import { Loading } from '../common/blocks/Loading';
import { Validation, regexToInputPattern } from '../../utils/validation';
import { LinkButton } from '../common/elements/LinkButton';
import { Error } from '../common/elements/Error';
import { ConfirmationCard } from '../common/blocks/ConfirmationCard';
import { sanitizeCmsHtml } from '../../texts';
import { PopUpBox, PopupContainer } from '../common/elements/PopUpBox';
import { NextButton } from '../common/elements/NextButton';
import Ticket from './Ticket';
import { isEmpty } from 'lodash';
import { BearerInfo } from '../common/blocks/BearerInfo';
import { ErrorMessageHandler } from '../common/blocks/ErrorMessageHandler';
import { StudentDetailsEditableField } from './StudentDetailsEditableField';

export const TYPES = {
	NAME: 'name',
	REFERREDACCOUNT: 'referredAccount',
	PERSONALIDENTITYNUMBER: 'personalIdentityNumber',
};

class StudentPopup extends Component {
	state = {
		showRegisterBearer: false,
		showDeleteWarning: false,
		serial: '',
		name: '',
		bearerIdToDelete: '',
		hasError: false,
		hasAddToGroupError: false,
		updateError: '',
		confirmDeleteGroup: null,
		showConfirmation: false,
		closePopupOnConfirmationClose: false,
		showGroupDeleteValidation: false,
		showRemoveReferredAccount: false,
		errorMessageReferral: '',
		phoneNumberRefferedAccount: '',
		phoneNumberRefferedAccountValid: undefined,
		nameEditable: false,
		personalIdentityNumberEditable: false,
		referredAccountEditable: false,
		newName: '',
		newPersonalIdentityNumber: '',
		newReferredAccount: '',
		updateStudentErrorMessage: '',
		showAddStudentToGroup: false,
		groupIdToAdd: '',
		showAssignTicket: false,
		selectedTicketOrderProduct: null,
		selectedTicketGroupId: '',
		assignTicketError: '',
	};

	componentDidMount() {
		const {
			getStudent,
			travellerId,
			hasLoadedBearers,
			hasLoadedTickets,
			groups,
		} = this.props;
		const student = getStudent(travellerId);

		this.setState({
			name: `${student.firstName} ${student.lastName}`,
			nameValid: true,
		});

		if (!hasLoadedTickets(travellerId))
			this.props.getStudentTickets(travellerId);

		if (!hasLoadedBearers(travellerId))
			this.props.loadStudentBearers(travellerId);

		this.props.getLoanTransactions(travellerId);

		const referredAccount = this.props.getReferredAccount(travellerId);

		if (referredAccount != null) {
			this.props.getReferredAccountLoanTransactions(referredAccount.referredAccountTravellerId);
		}

		if (isEmpty(groups)) this.props.getGroups();

		this.props.getTicketOrderProducts();
	}

	removeStudentFromGroup = async () => {
		const { travellerId } = this.props;
		const { groupId } = this.state.confirmDeleteGroup;

		await this.props.removeStudentFromGroup(groupId, travellerId);
		if (!this.props.hasDeleteGroupStudentError) {
			this.toggleConfirmationCard({ title: 'Elev borttagen', closePopupOnConfirmationClose: false });
		}
	};

	allowGroupDeletion = travellerId => {
		const { getStudent, canDeleteGroup } = this.props;
		const student = getStudent(travellerId);

		return canDeleteGroup([student]);
	};

	toggleConfirmationCard = ({
		title,
		closePopupOnConfirmationClose = true,
	} = {}) => {
		const {
			showConfirmation,
			closePopupOnConfirmationClose: shouldClosePopup,
		} = this.state;
		const { closePopup } = this.props;

		if (showConfirmation && shouldClosePopup) closePopup();

		this.setState(state => ({
			showConfirmation: !state.showConfirmation,
			showDeleteWarning: false,
			confirmDeleteGroup: null,
			confirmationTitle: title,
			closePopupOnConfirmationClose,
		}));
	};

	toggleGroupDelete = (groupId, travellerId) => {
		if (this.allowGroupDeletion(travellerId)) {
			this.setState({ confirmDeleteGroup: { groupId, travellerId } });
		} else {
			this.setState({ showGroupDeleteValidation: true });
		}
	};

	renderConfirmDelete = () => {
		const { closePopup, isLoadingGroupDeleteStudent, texts } = this.props;

		return (
			<PopUpBox>
				{(isLoadingGroupDeleteStudent) ? (
					<InnerContainer>
						<CloseCardButton onClick={closePopup} />
						<Loading />
					</InnerContainer>
				) : (
					<>
						<CloseCardButton onClick={closePopup} />
						<InnerContainer>
							<ConfirmDeleteText>
								<h1>Vänta lite!</h1>
								<div
									dangerouslySetInnerHTML={sanitizeCmsHtml(
										texts.school.studentpopup.deletegroup.deleteinformation
									)}
								/>
							</ConfirmDeleteText>
							<ConfirmDeleteButtons>
								<CancelDeleteGroupButton
									value="Tillbaka"
									onClick={() => this.setState({ confirmDeleteGroup: null })}
								>
									Tillbaka
								</CancelDeleteGroupButton>
								<ConfirmDeleteGroupButton
									value="Ta bort ur grupp"
									onClick={this.removeStudentFromGroup}
								>
									Ta bort ur grupp
								</ConfirmDeleteGroupButton>
							</ConfirmDeleteButtons>
						</InnerContainer>
					</>
				)}
			</PopUpBox>
		);
	};

	registerBearer = async () => {
		const { name, serial } = this.state;
		const { travellerId } = this.props;

		try {
			await this.props.createBearer(name, serial, travellerId);
			this.setState({
				showRegisterBearer: false,
			});
		} catch (error) {
			this.setState({ hasError: true });
		}
	};

	addStudentToGroup = async () => {
		const { groupIdToAdd } = this.state;
		const { travellerId } = this.props;

		const group = this.props.getGroupById(groupIdToAdd);

		try {
			this.setState({ hasAddToGroupError: false });
			await this.props.addStudentToGroup(group, travellerId);

			this.setState({ showAddStudentToGroup: false });
			this.toggleConfirmationCard({ title: 'Elev tillagd till grupp', closePopupOnConfirmationClose: false });
		} catch (error) {
			this.setState({ hasAddToGroupError: true });
		}
	}

	registerReferralAccount = async () => {
		const { getStudent, travellerId } = this.props;
		const { phoneNumberRefferedAccount } = this.state;

		let student = getStudent(travellerId);
		try {
			await this.props.connectAccount(
				student.contactId,
				phoneNumberRefferedAccount
			);
			const referredAccount = this.props.getReferredAccount(travellerId);
			this.props.getAllReferredAccountTickets([
				referredAccount.referredAccountTravellerId,
			]);
			this.props.getStudentTickets(travellerId);
			this.toggleConfirmationCard({
				title: 'Reseapp är nu kopplad',
			});
		} catch (error) {
			this.setState({ hasError: true, errorMessageReferral: error.message });
		}
	};

	deleteBearer = async () => {
		const { bearerIdToDelete } = this.state;
		const { travellerId } = this.props;

		try {
			await this.props.deleteStudentBearer(bearerIdToDelete, travellerId);
			this.toggleConfirmationCard({
				title: 'Resekortet har tagits bort',
			});
			// reload tickets to update tickets connected to removed bearer
			this.props.getStudentTickets(travellerId);
		} catch {
			this.setState({ showDeleteWarning: false, deleteError: true });
		}
	};

	removeReferredAccount = async () => {
		const { travellerId, getStudent } = this.props;
		const { contactId } = getStudent(travellerId);
		let showRemoveReferredAccountError = false;
		try {
			await this.props.deleteReferredAccounts(contactId, travellerId);
			this.props.getTicketsForStudentIds([travellerId]);
			this.toggleConfirmationCard({
				title: 'Koppling har tagits bort',
			});
		} catch {
			showRemoveReferredAccountError = true;
		}
		this.setState({
			showRemoveReferredAccount: false,
			removeReferredAccountError: showRemoveReferredAccountError,
		});
	};

	onShowDeleteWarning = bearerId => () => {
		this.setState({
			showDeleteWarning: true,
			bearerIdToDelete: bearerId,
		});
	};

	onHideDeleteWarning = () => this.setState({ showDeleteWarning: false });

	onShowRemoveReferredAccount = () => {
		this.setState({
			showRemoveReferredAccount: true,
		});
	};

	onHideRemoveReferredAccount = () =>
		this.setState({ showRemoveReferredAccount: false });

	toggle = () => {
		const { getStudent, travellerId } = this.props;
		const student = getStudent(travellerId);

		this.setState(state => ({
			showRegisterBearer: !state.showRegisterBearer,
			serial: '',
			serialValid: undefined,
			name: `${student.firstName} ${student.lastName}`,
		}));
	};

	toggleReferralAccount = () => {
		this.setState(state => ({
			showRegisterReferredAccount: !state.showRegisterReferredAccount,
		}));
	};

	toggleAddStudentToGroup = (status) => {
		this.setState({
			showAddStudentToGroup: status,
		});
	};

	handleChange = target => {
		this.setState({
			[target.id]: target.value,
			updateError: '',
			hasError: false,
			[`${target.id}Valid`]: this.isFieldValid(target.id, target.value),
		});
	};

	handleGroupChange = target => {
		if (target == null)
			return;

		this.setState({
			groupIdToAdd: target.id,
		});
	};

	handleBlur = ({ target }) =>
		this.setState({
			[`${target.id}Valid`]: this.isFieldValid(target.id, target.value),
		});

	validators = {
		name: value => value.length > 1,
		serial: value => value.length > 1 && Validation.serial.test(value),
		phoneNumberRefferedAccount: value =>
			value.length > 1 && Validation.mobile.test(value),
	};

	isFieldValid = (field, value) => this.validators[field](value);

	formattedBearers = bearers =>
		(bearers || []).map(b => ({ title: b.name, id: b.id, serial: b.serial }));

	enableEditing = type => {
		let nameEditable = false;
		let personalIdentityNumberEditable = false;
		let referredAccountEditable = false;

		if (type === TYPES.NAME) nameEditable = true;
		if (type === TYPES.REFERREDACCOUNT) referredAccountEditable = true;
		if (type === TYPES.PERSONALIDENTITYNUMBER) personalIdentityNumberEditable = true;

		this.setState({
			nameEditable,
			personalIdentityNumberEditable,
			referredAccountEditable,
		});
	};

	handleInputChange = changedInput => {
		this.setState({
			[changedInput.name]: changedInput.value,
		});
	};

	onSubmit = async submittedData => {
		const { getStudent, travellerId } = this.props;
		const student = getStudent(travellerId);
		let updateStudentErrorMessage = '';

		if (submittedData.type === 'name') {
			const name = submittedData.value;
			const fullName = name.split(" ");

			if (fullName.length < 2) {
				updateStudentErrorMessage = "NAME_NOT_COMPLETE";
			} else {
				const firstName = name.substring(0, name.indexOf(' '));
				const lastName = name.substring(name.indexOf(' ') + 1);

				try {
					await this.props.updateCustomerByTravellerId(
						travellerId,
						{
							firstName,
							lastName,
						},
					);
				} catch (error) {
					updateStudentErrorMessage = error.message;
				}
			}
		} else if (submittedData.type === 'personalIdentityNumber') {
			try {
				await this.props.updateCustomerByTravellerId(
					travellerId,
					{
						[submittedData.type]: submittedData.value,
					}
				);
			} catch (error) {
				updateStudentErrorMessage = error.message;
			}
		} else if (submittedData.type === 'referredAccount') {
			try {
				const traveller = await this.props.updateReferredAccount(student.contactId, submittedData.value);
				if (traveller.referredAccount != null) {
					await this.props.updateReferredAccountTickets(traveller.referredAccount.referredAccountTravellerId);
				}
			} catch (error) {
				updateStudentErrorMessage = error.message;
			}
		}

		this.setState({
			updateStudentErrorMessage,
		});
	};

	disableEditing = () => {
		this.setState({
			nameEditable: false,
			personalIdentityNumberEditable: false,
			referredAccountEditable: false,
		});
	};

	disableSaveButton = (oldValue, newValue) =>
		!newValue || newValue.length === 0 || oldValue === newValue;


	toggleAssignTicket = () => {
		this.setState(state => ({
			showAssignTicket: !state.showAssignTicket,
			selectedTicketOrderProduct: null,
			selectedTicketGroupId: '',
			assignTicketError: '',
		}));
	};

	onSelectTicketOrderProduct = item => {
		this.setState({ selectedTicketOrderProduct: item });
	};

	handleTicketGroupChange = target => {
		if (target == null) return;

		this.setState({
			selectedTicketGroupId: target.id,
		});
	};

	assignTicketToStudent = () => {
		const { getStudent, travellerId, closePopup } = this.props;
		const { selectedTicketOrderProduct, selectedTicketGroupId } = this.state;

		const student = getStudent(travellerId);

		if (!student || !selectedTicketOrderProduct) return;

		const group =
			student.groupInformation.length === 1
				? student.groupInformation[0]
				: student.groupInformation.find(
					g => String(g.groupId) === String(selectedTicketGroupId)
				);

		if (!group) {
			this.setState({
				assignTicketError: 'Eleven måste tillhöra en grupp för att kunna beställa biljett.',
			});
			return;
		}

		closePopup();

		this.props.push(SCHOOL.CONFIRM_TICKET_ORDER, {
			selectedGroup: {
				groupId: group.groupId,
				name: group.groupName,
			},
			ticketOrderRows: [
				{
					productId: selectedTicketOrderProduct.productId,
					contactId: student.contactId,
				},
			],
		});
	};

	render() {
		const {
			travellerId,
			getStudent,
			closePopup,
			isLoadingStudentBearers,
			hasDeleteGroupStudentError,
			selectStudentTickets,
			getBearers,
			isLoadingStudentTickets,
			getReferredAccount,
			getReferredAccountTickets,
			isSchoolTicketCancellable,
			isReferredSchoolTicketCancellable,
			isLoadingAddStudentToGroup,
			isUpdatingStudent,
			groups,
			ticketOrderProducts,
		} = this.props;
		const {
			showConfirmation,
			confirmDeleteGroup,
			showGroupDeleteValidation,
			nameValid,
			showDeleteWarning,
			serialValid,
			phoneNumberRefferedAccount,
			phoneNumberRefferedAccountValid,
			showRemoveReferredAccount,
			errorMessageReferral,
			nameEditable,
			personalIdentityNumberEditable,
			referredAccountEditable,
			newName,
			newPersonalIdentityNumber,
			newReferredAccount,
			updateStudentErrorMessage,
			showAssignTicket,
			selectedTicketOrderProduct,
			selectedTicketGroupId,
			assignTicketError,
		} = this.state;

		let student = getStudent(travellerId);
		if (!student) return null;

		const studentTicketGroups = student.groupInformation.map(g => ({
			id: g.groupId,
			title: g.groupName,
		}));

		const arrayGroupIds = new Set(student.groupInformation.map(g => g.groupId));
		const schoolGroups = Object.entries(groups.groups)
			.filter(([groupId]) => !arrayGroupIds.has(groupId))
			.map(([_, g]) => ({
				id: g.groupId,
				title: g.name,
			}));

		const bearers = getBearers(travellerId) || [];
		let formattedBearers = this.formattedBearers(bearers);
		let tickets = selectStudentTickets(travellerId);

		const referredAccount = getReferredAccount(student.travellerId);
		if (referredAccount) {
			const referredAccountTickets = getReferredAccountTickets(
				referredAccount.referredAccountTravellerId
			);
			tickets = tickets.concat(referredAccountTickets);
		}

		if (showConfirmation) {
			const { confirmationTitle } = this.state;
			return (
				<PopupContainer>
					<ConfirmationCard
						title={confirmationTitle}
						onClick={this.toggleConfirmationCard}
					/>
				</PopupContainer>
			);
		}

		if (showDeleteWarning) {
			return (
				<ConfirmBox
					title="Vänta lite!"
					info={
						<>
							<p>Är du säker på att du vill ta bort resekortet?</p>
							<ul>
								<li>
									Resekortet raderas från eleven och eleven kan inte längre resa
									på resekortet
								</li>
								<li>
									Finns det aktiva biljetter på resekortet kommer dessa läggas
									på elevens profil och kan kopplas till ett nytt resekort eller
									reseapp.
								</li>
							</ul>
						</>
					}
					onContinue={this.deleteBearer}
					onClose={this.onHideDeleteWarning}
					onBack={this.onHideDeleteWarning}
					confirmButtonText="Ta bort resekort"
				/>
			);
		}

		if (showRemoveReferredAccount) {
			return (
				<ConfirmBox
					title="Vänta lite!"
					info={
						<>
							<p>
								Är du säker på att du vill ta bort koppling mellan elev och
								privatkonto?
							</p>
						</>
					}
					onContinue={this.removeReferredAccount}
					onClose={this.onHideRemoveReferredAccount}
					onBack={this.onHideRemoveReferredAccount}
					confirmButtonText="Ta bort koppling"
				/>
			);
		}

		if (confirmDeleteGroup !== null) return this.renderConfirmDelete();

		if (isLoadingStudentBearers || isUpdatingStudent || isLoadingAddStudentToGroup) {
			return (
				<PopUpBox>
					<CloseCardButton onClick={closePopup} />
					<InnerContainer>
						<Loading />
					</InnerContainer>
				</PopUpBox>
			);
		}

		const fullName = `${student.firstName} ${student.lastName}`

		return (
			<PopUpBox>
				<CloseCardButton onClick={closePopup} />
				<InnerContainer>
					<StudentDetailsEditableField
						type={TYPES.NAME}
						currentValue={fullName}
						enableEdit={this.enableEditing}
						value={newName}
						isEditable={nameEditable}
						handleChange={this.handleInputChange}
						changeDisabled={personalIdentityNumberEditable || referredAccountEditable}
						submitDisabled={
							this.disableSaveButton(
								fullName,
								newName,
							)
						}
						handleSubmit={this.onSubmit}
						onBackClick={this.disableEditing}
					/>

					<Line />

					<StudentDetailsEditableField
						type={TYPES.PERSONALIDENTITYNUMBER}
						label={'Personnummer'}
						currentValue={student.personalIdentityNumber}
						enableEdit={this.enableEditing}
						value={newPersonalIdentityNumber}
						isEditable={personalIdentityNumberEditable}
						handleChange={this.handleInputChange}
						changeDisabled={referredAccountEditable || nameEditable}
						submitDisabled={
							this.disableSaveButton(
								student.personalIdentityNumber,
								newPersonalIdentityNumber,
							)
						}
						handleSubmit={this.onSubmit}
						onBackClick={this.disableEditing}
					/>

					{student.homeCounty && (
						<InfoWrapper>
							<span>Hemkommun</span>
							<span>{student.homeCounty}</span>
						</InfoWrapper>
					)}
					{this.state.updateError && (
						<UpdateMessage>
							<div style={{ color: '#ff0000' }}>{this.state.updateError}</div>
						</UpdateMessage>
					)}
					<InfoWrapper>
						{referredAccount ? (
							referredAccount.referredAccountPhoneNumber ? (
								<>
									<div style={{ width: "100%" }} >
										<StudentDetailsEditableField
											type={TYPES.REFERREDACCOUNT}
											label={'Reseapp'}
											currentValue={referredAccount.referredAccountPhoneNumber}
											enableEdit={this.enableEditing}
											value={newReferredAccount}
											isEditable={referredAccountEditable}
											handleChange={this.handleInputChange}
											changeDisabled={personalIdentityNumberEditable || nameEditable}
											submitDisabled={
												this.disableSaveButton(
													referredAccount.referredAccountPhoneNumber,
													newReferredAccount,
												)
											}
											handleSubmit={this.onSubmit}
											onBackClick={this.disableEditing}
											handleShowRemove={this.onShowRemoveReferredAccount}
										/>
									</div>
								</>
							) : (
								<span>Ja</span>
							)
						) : (
							<>
								<span>Reseapp</span>
								<NoData>Nej</NoData>
							</>
						)}
					</InfoWrapper>
					{this.state.removeReferredAccountError && (
						<ErrorMessage>
							Det gick inte att ta bort koppling. Vänligen försök igen.
						</ErrorMessage>
					)}

					{updateStudentErrorMessage && (
						ErrorMessageHandler(updateStudentErrorMessage)
					)}

					{this.state.showRegisterReferredAccount ? (
						<RegisterReferralAccount>
							<div className="form-group">
								<TextInput
									type="tel"
									value={phoneNumberRefferedAccount}
									handleChange={this.handleChange}
									className="form-control"
									id="phoneNumberRefferedAccount"
									placeholder="46712345678"
								/>
								{phoneNumberRefferedAccount.length > 1 &&
									!phoneNumberRefferedAccountValid && (
										<ErrorMessage>
											Vänligen ange telefonnummer i formatet '46712345678'.
										</ErrorMessage>
									)}
							</div>

							{this.state.hasError && ErrorMessageHandler(errorMessageReferral)}

							<ButtonWrapper>
								<CancelRegisterReferralAccountButton
									onClick={this.toggleReferralAccount}
								>
									Avbryt
								</CancelRegisterReferralAccountButton>
								<RegisterReferralAccountButton
									onClick={this.registerReferralAccount}
									disabled={!phoneNumberRefferedAccountValid}
								>
									Koppla konto
								</RegisterReferralAccountButton>
							</ButtonWrapper>
						</RegisterReferralAccount>
					) : (
						!referredAccount && (
							<ButtonWrapper>
								<AddButton onClick={this.toggleReferralAccount}>
									<span>Koppla konto</span>
								</AddButton>
							</ButtonWrapper>
						)
					)}
					<Line />
					{<h4>Resekort</h4>}
					{isEmpty(bearers) && <NoData>Inga registrerade resekort</NoData>}
					{bearers.map((bearer, idx) => (
						<IconContainer key={idx}>
							<BearerInfo bearer={bearer} />
							{!isTravelCardSmartPhone(bearer) && (
								<TrashIcon
									className="svg-icon"
									role="button"
									onClick={this.onShowDeleteWarning(bearer.id)}
								/>
							)}
						</IconContainer>
					))}
					{this.state.deleteError && (
						<ErrorMessage>
							Det gick inte att ta bort resekortet. Vänligen försök igen.
						</ErrorMessage>
					)}
					{this.state.showRegisterBearer ? (
						<RegisterBearerContainer>
							<div>
								<h5>Lägg till resekort</h5>
							</div>
							{this.state.hasError && (
								<ErrorMessage>
									Det gick inte att registrera resekortet. Vänligen försök igen.
								</ErrorMessage>
							)}
							<div className="form-group">
								<Label htmlFor="serial">Kortnummer*</Label>
								<TextInput
									type="text"
									value={this.state.serial}
									handleChange={this.handleChange}
									className="form-control"
									id="serial"
									placeholder=""
									pattern={regexToInputPattern(Validation.serial)}
									validateOnChange={true}
								/>
								{typeof serialValid !== 'undefined' && !serialValid && (
									<ErrorMessage>Kortnumret är inte rätt ifyllt</ErrorMessage>
								)}
							</div>
							<div className="form-group">
								<Label htmlFor="name">Namn på kort* </Label>{' '}
								<TextInput
									type="text"
									value={this.state.name}
									handleChange={this.handleChange}
									className="form-control"
									id="name"
									placeholder=""
									maxLength="30"
									onBlur={this.handleBlur}
								/>
								{typeof nameValid !== 'undefined' && !nameValid && (
									<ErrorMessage>Namnet är inte rätt ifyllt</ErrorMessage>
								)}
							</div>
							<ButtonWrapper>
								<CancelRegisterBearerButton onClick={this.toggle}>
									Avbryt
								</CancelRegisterBearerButton>
								<RegisterBearerButton
									onClick={this.registerBearer}
									disabled={!serialValid || !nameValid}
								>
									Spara
								</RegisterBearerButton>
							</ButtonWrapper>
						</RegisterBearerContainer>
					) : (
						<ButtonWrapper>
							<AddButton onClick={this.toggle}>
								<span>Lägg till resekort</span>
							</AddButton>
						</ButtonWrapper>
					)}
					<Line />
					<h4>Biljetter</h4>

					<ButtonWrapper>
						<AddButton onClick={this.toggleAssignTicket}>
							<span>Beställ biljett</span>
						</AddButton>
					</ButtonWrapper>

					{showAssignTicket && (
						<RegisterBearerContainer>
							<div className="form-group">
								<Label htmlFor="ticketOrderProducts">Biljett</Label>
								<TicketOrderProductsDropdown
									id="ticketOrderProducts"
									items={(ticketOrderProducts || []).map(p => ({
										...p,
										title: p.name,
									}))}
									onSelect={this.onSelectTicketOrderProduct}
									renderSelectedItem={item => {
										const fullTitle = `${item.title} - ${item.spatialTitle}`;

										return (
											<TicketOrderProductName title={fullTitle}>
												{fullTitle}
											</TicketOrderProductName>
										);
									}}
									renderItem={item => {
										const fullTitle = `${item.title} - ${item.spatialTitle}`;

										return (
											<TicketOrderProductName title={fullTitle}>
												{fullTitle}
											</TicketOrderProductName>
										);
									}}
								/>
							</div>

							{student.groupInformation.length > 1 && (
								<div className="form-group">
									<Label htmlFor="selectedTicketGroupId">Grupp</Label>
									<Select
										value={selectedTicketGroupId}
										id="selectedTicketGroupId"
										placeholder="Välj grupp"
										onSelect={this.handleTicketGroupChange}
										items={studentTicketGroups}
									/>
								</div>
							)}

							{assignTicketError && (
								<ErrorMessage>{assignTicketError}</ErrorMessage>
							)}

							<ButtonWrapper>
								<CancelRegisterBearerButton onClick={this.toggleAssignTicket}>
									Avbryt
								</CancelRegisterBearerButton>
								<RegisterBearerButton
									onClick={this.assignTicketToStudent}
									disabled={
										!selectedTicketOrderProduct ||
										isEmpty(student.groupInformation) ||
										(student.groupInformation.length > 1 && !selectedTicketGroupId)
									}
								>
									Tilldela
								</RegisterBearerButton>
							</ButtonWrapper>
						</RegisterBearerContainer>
					)}

					{isLoadingStudentTickets && <Loading text="Laddar biljetter..." />}
					{isEmpty(tickets) ? (
						<NoData>Eleven har inga biljetter att visa</NoData>
					) : (
						tickets.map(x => (
							<Ticket
								key={x.id}
								product={x}
								bearers={formattedBearers}
								onToggleConfirmationCard={this.toggleConfirmationCard}
								travellerId={travellerId}
								closePopup={this.props.closePopup}
								isReferredTicket={travellerId !== x.travellerId}
								isCancellable={isSchoolTicketCancellable(x.id) || isReferredSchoolTicketCancellable(x.id)}
							/>
						))
					)}{' '}
					<Line />
					<h4>Grupper</h4>
					{student.groupInformation.map((group, idx) => (
						<Fragment key={idx}>
							{showGroupDeleteValidation && (
								<DeleteGroupValidationText>
									Eleven kan ej tas bort ur denna grupp på grund av en aktiv
									biljett
								</DeleteGroupValidationText>
							)}
							<IconContainer>
								<GroupIcon />
								<GroupName>{group.groupName}</GroupName>
								<LinkButton
									onClick={() =>
										this.toggleGroupDelete(group.groupId, student.travellerId)
									}
								>
									<TrashIcon />
								</LinkButton>
							</IconContainer>
							{hasDeleteGroupStudentError && <Error />}
						</Fragment>
					))}

					{schoolGroups.length > 0 && (!this.state.showAddStudentToGroup ? (
						<AddButton onClick={() => this.toggleAddStudentToGroup(true)}>
							<span>Lägg till elev i grupp</span>
						</AddButton>
					) : (
						<RegisterBearerContainer>
							{this.state.hasAddToGroupError && (
								<ErrorMessage>
									Det gick inte att lägga till elev i grupp.
								</ErrorMessage>
							)}

							<div className="form-group">
								<Label htmlFor="studentGroup">Lägg till elev i grupp</Label>
								<Select
									value={this.state.groupIdToAdd}
									id="studentGroup"
									placeholder="Välj"
									onSelect={this.handleGroupChange}
									items={schoolGroups}
								/>
							</div>

							<ButtonWrapper>
								<CancelRegisterBearerButton onClick={() => this.toggleAddStudentToGroup(false)}>
									Avbryt
								</CancelRegisterBearerButton>
								<RegisterBearerButton
									onClick={this.addStudentToGroup}
									disabled={false}
								>
									Lägg till
								</RegisterBearerButton>
							</ButtonWrapper>
						</RegisterBearerContainer>
					))}

					{isEmpty(student.groupInformation) && (
						<NoData>Eleven tillhör ingen grupp</NoData>
					)}
					<Line />
				</InnerContainer>
			</PopUpBox>
		);
	}
}

const RegisterBearerContainer = styled.div`
	margin-top: 1em;
`;

const RegisterReferralAccount = styled.div`
	margin-top: 1em;
`;

const RegisterBearerButton = styled(NextButton)`
	max-width: 250px;
	width: 48%;
`;

const RegisterReferralAccountButton = styled(NextButton)`
	max-width: 250px;
	width: 48%;
`;

const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	padding-top: 1em;
	padding-bottom: 1em;
`;

const CancelRegisterBearerButton = styled(SecondaryButton)`
	display: block;
	width: 48%;
	font-weight: normal;
	background-color: white;
	border: 1px solid #645b5b;
	color: #645b5b;
`;

const CancelRegisterReferralAccountButton = styled(SecondaryButton)`
	display: block;
	width: 48%;
	font-weight: normal;
	background-color: white;
	border: 1px solid #645b5b;
	color: #645b5b;
`;

const UpdateMessage = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 0.5em;
`;

const NoData = styled.div`
	font-style: italic;
	color: ${props => props.theme.light_grey};
`;

const IconContainer = styled.div`
	text-align: left;
	display: flex;
	justify-content: space-between;
	margin-bottom: 1em;
`;

const GroupName = styled.div`
	flex-grow: 1;
`;

const GroupIcon = styled(GroupImg)`
	width: 25px;
	margin-right: 15px;
`;

const ErrorMessage = styled.p`
	margin-top: 0.5em;
	color: crimson;
	text-align: left;
`;

const TrashIcon = styled(TrashImg)`
	margin-left: 10px;

	&:hover {
		cursor: pointer;
	}
`;

const InnerContainer = styled.div`
	width: 380px;
	max-width: 100%;
`;
const Line = styled.div`
	border-bottom: 1px solid #ccc;
	margin-top: 2em;
	margin-bottom: 2em;
`;

const InfoWrapper = styled.div`
	padding-bottom: 1.5em;
	padding-top: 1.5em;
	display: flex;
	justify-content: space-between;
	align-items: center;

	span:first-child,
	label {
		font-weight: 700;
	}
`;

const DeleteGroupValidationText = styled.p`
	color: rgb(255, 0, 0);
	font-family: ${props => props.theme.text};
	font-size: 12px;
	font-style: italic;
`;

const ConfirmDeleteText = styled.div`
	h1 {
		margin: 0 0 25px;
	}

	ul {
		text-align: left;
		padding-inline-start: 18px;
	}
`;

const ConfirmDeleteButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 64px;
`;

const ConfirmDeleteGroupButton = styled(SecondaryButton)`
	display: block;
	width: 48%;
	padding: 10px 30px;
	margin-bottom: 1em;
	font-weight: normal;
`;

const CancelDeleteGroupButton = styled(ConfirmDeleteGroupButton)`
	background-color: white;
	border: 1px solid #645b5b;
	color: #645b5b;
`;

const TicketOrderProductsDropdown = styled(Dropdown)`
	display: block;
	margin-bottom: 1em;

	> div {
		overflow-y: auto;
		max-height: 420px;
	}

	div:first-of-type {
		overflow-y: unset;
		max-height: unset;
	}
`;

const TicketOrderProductName = styled.span`
	display: block;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

function mapStateToProps(state) {
	return {
		groups: getSchoolGroups(state),
		getGroupById: getGroupById(state),
		getStudent: getStudentById(state),
		selectStudentTickets: selectStudentTickets(state),
		hasLoadedTickets: hasLoadedStudentTickets(state),
		hasLoadedBearers: hasLoadedStudentBearers(state),
		getBearers: getStudentBearers(state),
		isLoadingStudentBearers: isLoadingStudentBearers(state),
		hasCreateBearerError: hasCreateStudentBearerError(state),
		isLoadingGroupDeleteStudent: isLoadingGroupDeleteStudent(state),
		isLoadingAddStudentToGroup: isLoadingAddStudentToGroup(state),
		hasDeleteGroupStudentError: hasDeleteGroupStudentError(state),
		isLoadingStudentTickets: isLoadingStudentTickets(state),
		isUpdatingStudent: isUpdatingStudent(state),
		getReferredAccount: getReferredAccount(state),
		getReferredAccountTickets: getReferredAccountTickets(state),
		isSchoolTicketCancellable: isSchoolTicketCancellable(state),
		isReferredSchoolTicketCancellable: isReferredSchoolTicketCancellable(state),
		canDeleteGroup: canDeleteGroup(state),
		ticketOrderProducts: getAllTicketOrderProducts(state),
	};
}

export default withTextContext(
	connect(mapStateToProps, {
		...groupActions,
		...studentActions,
		...travellerActionCreators,
		...parameterActionCreators,
		...orderActions,
		...schoolActions,
		push,
	})(StudentPopup)
);
